export interface CRFRProps {
  first_name: string;
  last_name: string;
  dni: string;
  email: string;
  status?: number[];
}
export const getCRFilterRequest = (event: CRFRProps) => {
  return {
    ...(event?.first_name
      ? {
          Nombre: event?.first_name,
        }
      : {}),
    ...(event?.last_name
      ? {
          Apellido: event?.last_name,
        }
      : {}),
    ...(event?.dni
      ? {
          Dni: event?.dni,
        }
      : {}),
    ...(event?.email
      ? {
          Mail: event?.email,
        }
      : {}),
    ...(event?.status?.length
      ? {
          IdEstado: event?.status,
        }
      : {}),
  };
};
